import React from "react"


export const Services = () => {
    return (
        <div className="max-w-screen-xl mb-auto">
            <div className="pt-20"></div>
            <h2 className="text-4xl font-bold mb-4">Dienste</h2>
            {/* Text Column */}
            <div
                data-aos="fade-left"
                className="p-6 grid grid-cols-1 md:grid-cols-2 gap-8"
            >
                {/* Card 1 */}
                <div className="bg-white rounded-lg shadow-md p-6 flex flex-col">
                    <h3 className="text-3xl font-bold mb-2">Tägliches Gebet (Kinder & Erwachsene)</h3>
                    <p className="text-gray-600 mb-4">
                        <strong>Zeit:</strong> 18:00 bis 18:30<br />
                        <strong>Plattform:</strong> Zoom Meeting<br />
                         <strong>Link:</strong>
                        <a
                            href="https://us04web.zoom.us/j/71769195371?pwd=bCAGkVN43IKqtyQXdUdXaUUbCRVqCp.1"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-600 hover:text-blue-800 underline"
                        >
                            Zoom Meeting beitreten
                        </a>
                        <br />
                        <strong>Meeting ID:</strong> 717 6919 5371<br />
                        <strong>Passcode:</strong> jesus
                    </p>
                </div>
                {/* Card 2 */}
                <div className="bg-white rounded-lg shadow-md p-6 flex flex-col">
                    <h3 className="text-3xl font-bold mb-2">Bibelstudium für Kinder</h3>
                    <p className="text-gray-600 mb-4">
                        <strong>Zeit:</strong> 18:30 bis 19:00<br />
                        <strong>Plattform:</strong> Zoom Meeting<br />
                         <strong>Link:</strong>
                        <a
                            href="https://us04web.zoom.us/j/73084506301?pwd=UCkUg7aAza3euFh3HYUTkjEXy1OZqQ.1"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-600 hover:text-blue-800 underline"
                        >
                            Zoom Meeting beitreten
                        </a>
                        <br />
                        <strong>Meeting ID:</strong> 730 8450 6301<br />
                        <strong>Passcode:</strong> jesus
                    </p>
                </div>
                {/* Card 3 */}
                <div className="bg-white rounded-lg shadow-md p-6 flex flex-col">
                    <h3 className="text-3xl font-bold mb-2">Lobpreisung & Hymne (Kinder & Erwachsene)</h3>
                    <p className="text-gray-600 mb-4">
                        <strong>Zeit:</strong> Freitags, 20:00 bis 20:40<br />
                        <strong>Plattform:</strong> Zoom Meeting<br />
                         <strong>Link:</strong>
                        <a
                            href="https://us04web.zoom.us/j/73561144188?pwd=6FkVRZr4cBeyqLhYdmkE9ID0LUGOxa.1"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-600 hover:text-blue-800 underline"
                        >
                            Zoom Meeting beitreten
                        </a>
                        <br />
                        <strong>Meeting ID:</strong> 735 6114 4188<br />
                        <strong>Passcode:</strong> jesus
                    </p>
                </div>
                {/* Card 4 */}
                <div className="bg-white rounded-lg shadow-md p-6 flex flex-col">
                    <h3 className="text-3xl font-bold mb-2">Bibelstunde (Erwachsene)</h3>
                    <p className="text-gray-600 mb-4">
                        <strong>Zeit:</strong> Sonntags, 19:15 bis 19:45<br />
                        <strong>Plattform:</strong> Zoom Meeting<br />
                         <strong>Link:</strong>
                        <a
                            href="https://us04web.zoom.us/j/79140195701?pwd=Fnvd2oRPVEDfvQYQoMD0ACV64uri7R.1"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-600 hover:text-blue-800 underline"
                        >
                            Zoom Meeting beitreten
                        </a>
                        <br />
                        <strong>Meeting ID:</strong> 791 4019 5701<br />
                        <strong>Passcode:</strong> jesus
                    </p>
                </div>
            </div>
            </div>
    )
}
